import "./CopyTextControl.scss";
import { copyLink } from "@/common/utils/share";

export const CopyTextControl = (props: {
  value: string;
  onClick?: () => void;
}) => {
  const onClick = async () => {
    await copyLink(props.value);

    if (props.onClick) {
      props.onClick();
    }
  };

  return (
    <div className="copyControl">
      <input type="text" readOnly value={props.value} />
      <button onClick={onClick} aria-label="copy text to clipboard">Copy</button>
    </div>
  );
};
